export const RATE_TYPE = {
  LIKE: 'like',
  DISLIKE: 'dislike',
};
